import { SyndicationFeed } from "api/syndicationFeed";

export const ADD_LISTINGS_LABEL = "Add listings";

export const SYNDICATION_FEED_LABEL: Record<SyndicationFeed, string> = {
  zillow: "Zillow",
  zumper: "Zumper",
  dwellsy: "Dwellsy",
  apartments_com: "Apartments.com",
  affordable_housing_com: "Affordable Housing"
};
